<template>
  <span
    :class="`notification tw-relative ${
      planOrgDetail ? '' : 'cursor-pointer-unset'
    }`"
  >
    <div v-if="parseInt(systemActions) > 0" class="notification-dot"></div>
    <span class="notification-icon-wrapper">
      <p v-if="parseInt(notificationCount) > 0" class="notification-count">
        {{ parseInt(notificationCount) > 9 ? `9+` : notificationCount }}
      </p>

      <img
        src="/img/bell_icon.svg"
        alt="notification"
        class="notification-icon"
      />
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const systemActions = computed(() => store.state.Notification.systemActions);

const planOrgDetail = computed(() => {
  const orgPlan = store.getters["Org/getPlanDetails"];
  return orgPlan && orgPlan.planId ? true : false;
});

defineProps<{ notificationCount: string }>();
</script>

<style scoped>
.notification {
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.notification .notification-icon {
  width: 13px;
  height: 13px;
}

.notification .notification-icon-wrapper {
  position: relative;
}

.notification .notification-count {
  position: absolute;
  top: -1px;
  right: -7px;
  background: rgba(247, 85, 60, 1);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7px;
  height: 7px;
  padding: 7px;
  border-radius: 50%;
  font-size: 10px;
  text-align: center;
  font-weight: bolder;
}

.notification .notification-dot {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background-color: #f7553c;
  border-radius: 50%;
  border: 1px solid #fff;
}

.notification .notification-count:empty {
  display: none;
}

.cursor-pointer-unset {
  cursor: unset !important;
}
</style>
